import { render, staticRenderFns } from "./StartSideNoActiveOffers.vue?vue&type=template&id=e2f88a44"
import script from "./StartSideNoActiveOffers.vue?vue&type=script&lang=js"
export * from "./StartSideNoActiveOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports